<template>
  <div
    :class="[
      'ai-actionable cursor-pointer',
      isButton ? 'button button--fixed' : 'badge badge--absolute',
    ]"
    @click.stop.prevent="$emit('click')"
  >
    <v-icon color="blue lighten-1" size="12" class="pa-0 ma-0"
      >mdi-creation-outline</v-icon
    >
    <span class="caption ml-1"> {{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'SummaryActionable',

  props: {
    text: String,
    isButton: Boolean,
  },
}
</script>
<style lang="scss" scoped>
.ai-actionable {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
  background: linear-gradient($color-blue-darken2 0 0) padding-box,
    // This is the filling color.
      conic-gradient(
        from 180deg at 50% 50%,
        #b3d3ff 0deg,
        #3882f0 152.05deg,
        #b3d3ff 360deg
      )
      border-box;
  padding-top: 9px;
  padding-bottom: 9px;
  border: 2px solid transparent;
}

.ai-actionable.badge {
  width: 44px;
  height: 20px;
  border-radius: 4px;

  &--absolute {
    position: absolute;
    top: 8px;
    right: 8px;
  }
}

.ai-actionable.button {
  height: 32px;
  max-width: fit-content;
  padding-left: 16px;
  padding-right: 16px;
  border-radius: 17px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

  &--fixed {
    position: fixed;
    z-index: 1;
    bottom: 30px;
    right: 98px;
  }

  span {
    margin-left: 8px !important;
    font-size: $font-size-14 !important;
    font-weight: 500;
    line-height: 16px;
  }
}
</style>
